import { render, staticRenderFns } from "./LpColorPicker.vue?vue&type=template&id=f1f3d4c4&scoped=true"
import script from "./LpColorPicker.vue?vue&type=script&lang=js"
export * from "./LpColorPicker.vue?vue&type=script&lang=js"
import style0 from "./LpColorPicker.vue?vue&type=style&index=0&id=f1f3d4c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f3d4c4",
  null
  
)

export default component.exports